export default function ReversalIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g
        stroke={'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M2.25 5.25v4.5h4.5" />
        <path d="M6.337 18a8.25 8.25 0 1 0-.171-11.834L2.25 9.75" />
      </g>
    </svg>
  );
}
